export default __webpack_public_path__ + "static/media/telefone_sip.d91232c4.jpg";